<script setup lang="ts">
import DepositRequestsContainer from './containers/DepositRequestsContainer.vue'
</script>

<template>
  <DepositRequestsContainer />
</template>
